import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { useTheme } from "@mui/material/styles";
import { Box, Skeleton, Stack, Typography } from "@mui/material";
import { Dot } from "../UIElements/svgIcons";
import { useNavigate } from "react-router-dom";
import { headerSty, contentSty } from "../table-styles";
import {
  formatDate,
  formatDateAndTimeFromString,
  formatDateFromString,
  formatDecimal,
  formatJobType,
  limitToSeven,
} from "../../utils/url-id";

export default function SupportTable({
  data,
  loading,
  modalState,
  handleModal,
}: any) {
  const theme = useTheme();
  const headStyles = { ...headerSty, color: theme.palette.neutral.main };
  const contentStyles = { ...contentSty };

  const navigate = useNavigate();
  const [openRow, setOpenRow] = React.useState<number | null>(null); // Track which row is open

  const handleToggleOpen = (rowId: number) => {
    setOpenRow((prevOpenRow) => (prevOpenRow === rowId ? null : rowId));
  };

  return (
    <TableContainer
      component={Paper}
      sx={{
        my: 1,
        background: theme.palette.common.white,
        borderRadius: 1,
        border: 0,
        boxShadow: "none",
        minHeight: 400,
      }}
    >
      <Table
        sx={{
          minWidth: 650,
          boxShadow: "none",
          my: 2,
          paddingX: 2,
          border: 0,
        }}
        aria-label="simple table"
      >
        <TableHead sx={{ paddingX: 2, border: 0 }}>
          <TableRow>
            <TableCell sx={{ ...headStyles }}>Ticket ID</TableCell>
            <TableCell sx={{ ...headStyles }}>Facility Name</TableCell>

            <TableCell sx={{ ...headStyles }}>Tickets Type</TableCell>
            <TableCell sx={{ ...headStyles }}>Created On</TableCell>
            <TableCell sx={{ ...headStyles }}>Status</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((row: any, index: number) => (
            <TableRow key={index} onClick={() => handleModal(row)}>
              <TableCell sx={contentStyles}>{limitToSeven(row?._id)}</TableCell>
              <TableCell sx={contentStyles}>{row?.name}</TableCell>

              <TableCell sx={{ ...contentStyles }}>{row?.issue_type}</TableCell>

              <TableCell sx={{ ...contentStyles }}>
                {formatDateAndTimeFromString(row?.created_at)}
              </TableCell>
              <TableCell sx={{ ...contentStyles }}>
                <SupportEmpStatus status={row?.status} />
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      {data?.length === 0 && !loading && (
        <Box
          sx={{
            height: 200,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Typography
            variant="h4"
            sx={{ fontWeight: 600, color: theme.palette.neutral.main }}
          >
            No Support Created.
          </Typography>
        </Box>
      )}
      {loading && (
        <Box sx={{ width: "96%", mx: "auto" }}>
          <Skeleton
            variant="rounded"
            width={"100%"}
            height={60}
            sx={{ my: 2 }}
          />
          <Skeleton
            variant="rounded"
            width={"100%"}
            height={60}
            sx={{ my: 2 }}
          />
          <Skeleton
            variant="rounded"
            width={"100%"}
            height={60}
            sx={{ my: 2 }}
          />
          <Skeleton
            variant="rounded"
            width={"100%"}
            height={60}
            sx={{ my: 2 }}
          />
        </Box>
      )}
    </TableContainer>
  );
}
export const SupportEmpStatus: React.FC<{
  status: "resolved" | "unresolved" | "pending" | string;
}> = ({ status }) => {
  const theme = useTheme();

  const getStatusStyles = (status: string) => {
    switch (status?.toLowerCase()) {
      case "unresolved":
        return {
          color: theme.palette.error.main,
          backgroundColor: "#f6685e6b",
        };
      case "resolved":
        return {
          color: theme.palette.common.white,
          backgroundColor: theme.palette.success.main,
        };
      case "pending":
        return {
          color: theme.palette.common.white,
          backgroundColor: theme.palette.warning.light,
        };
      default:
        return {
          color: theme.palette.common.white,
          backgroundColor: theme.palette.warning.light,
        };
    }
  };

  const statusStyles = getStatusStyles(status);

  return (
    <Stack
      direction="row"
      justifyContent="center"
      sx={{ width: 100, mx: "auto" }}
    >
      <Box
        sx={{
          marginX: 1,
          paddingY: 1,
          paddingX: 3,
          borderRadius: "3px",
          fontSize: 12,
          fontFamily: "Lexend",
          textTransform: "uppercase",
          ...statusStyles,
        }}
      >
        {status ?? "pending"}
      </Box>
    </Stack>
  );
};

// const TableDots: React.FC<{
//   rowId: number;
//   isOpen: boolean;
//   toggleOpen: (id: number) => void;
// }> = ({ rowId, isOpen, toggleOpen }) => {
//   const [open, setOpen] = React.useState(false);
//   const navigate = useNavigate();
//   const handleOpen = () => {
//     setOpen(!open);
//   };
//   return (
//     <Box
//       sx={{
//         position: "relative",
//         display: "flex",
//         justifyContent: "center",
//         alignItems: "center",
//         zIndex: 20,
//       }}
//     >
//       <Box
//         onClick={handleOpen}
//         sx={{
//           cursor: "pointer",
//           width: "20px",
//         }}
//       >
//         <Dot />
//       </Box>
//       {open && (
//         <Box
//           sx={{
//             background: "#b4c2e9",
//             position: "absolute",
//             top: 18,
//             right: 0,
//             borderRadius: "12px",
//             padding: "8px 12px",
//             zIndex: 20,
//             width: 125,
//             cursor: "pointer",
//           }}
//         >
//           <Stack sx={{ my: 1 }}>
//             <Typography
//               onClick={() => navigate(`/support/${rowId}`)}
//               variant="caption"
//               sx={{
//                 fontWeight: 700,
//                 color: "#1E1E1E",
//               }}
//             >
//               View Post
//             </Typography>
//           </Stack>
//           <Stack sx={{ my: 1 }}>
//             <Typography
//               variant="caption"
//               sx={{
//                 fontWeight: 700,
//                 color: "#1E1E1E",
//               }}
//             >
//               Reply
//             </Typography>
//           </Stack>
//           <Stack sx={{ my: 1 }}>
//             {" "}
//             <Typography
//               variant="caption"
//               sx={{
//                 fontWeight: 700,
//                 color: "#1E1E1E",
//               }}
//             >
//               Mark as Resolved
//             </Typography>
//           </Stack>
//         </Box>
//       )}
//     </Box>
//   );
// };
